import { GridRowGroupingState } from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { toPascalCase } from '@omnea-app/packages/universal/string-utils/toPascalCase'

export const ROW_GROUPING_NONE_GROUPING_TEXT_VALUE = 'NONE'

// MUI's single-grouping column field, injected into sortModel when a user sorts by the group-column
// header. It is internal to @mui/x-data-grid-pro (not re-exported from the package root), so it is
// pinned here rather than imported.
export const ROW_GROUPING_SINGLE_GROUPING_FIELD = '__row_group_by_columns_group__'

export const ROW_GROUPING_RENDERD_COLUMN_TYPE = 'rowGroupByColumnsGroup'

export type RowGroupingModelCriteria = string | undefined

// NOTE (Dalyan): Until we introduce ability to group by multiple rows,
// we will only get the first model criteria element from the
// row grouping model
export const getRowGroupingModelCriteriaFromGridRowGroupingState = (
  rowGroupingState: GridRowGroupingState | undefined
): RowGroupingModelCriteria => rowGroupingState?.model[0]

export const getRowGroupingColumnTableCellValue = (value?: string): string | null => {
  if (isNil(value)) {
    console.error("Argument 'value' is nullish, and thus invalid")
    return null
  }

  if (value === ROW_GROUPING_NONE_GROUPING_TEXT_VALUE) {
    return ROW_GROUPING_NONE_GROUPING_TEXT_VALUE
  }

  return toPascalCase(value)
}
